import {match} from 'ts-pattern';

import {always} from 'ramda';

export const resolveCustomFieldBooleanValue = (value: unknown) =>
  match(value)
    .with('true', true, always(true))
    .with('false', false, always(false))
    .otherwise(always(null));
